type SwitchSize = 'sm' | 'md'

interface SwitchProps {
    checked: boolean
    onChange: (checked: boolean) => void
    label?: string
    ariaLabel?: string
    disabled?: boolean
    size?: SwitchSize
    className?: string
}

const sizeClasses: Record<SwitchSize, { track: string; thumb: string; translate: string }> = {
    sm: { track: 'h-5 w-9', thumb: 'h-4 w-4', translate: 'translate-x-[18px]' },
    md: { track: 'h-6 w-10', thumb: 'h-5 w-5', translate: 'translate-x-[18px]' },
}

export const Switch = ({ checked, onChange, label, ariaLabel, disabled, size = 'sm', className = '' }: SwitchProps) => {
    return (
        <label className={`inline-flex items-center gap-2 ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'} ${className}`}>
            <button
                type="button"
                role="switch"
                aria-checked={checked}
                aria-label={ariaLabel ?? label}
                disabled={disabled}
                onClick={() => onChange(!checked)}
                className={`relative inline-flex shrink-0 items-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-900 ${sizeClasses[size].track} ${checked ? 'bg-blue-600 dark:bg-blue-500' : 'bg-slate-300 dark:bg-slate-600'} ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
            >
                <span
                    className={`inline-block rounded-full bg-white shadow transition-transform ${sizeClasses[size].thumb} ${checked ? sizeClasses[size].translate : 'translate-x-[2px]'}`}
                />
            </button>
            {label && <span className="text-sm text-slate-700 dark:text-slate-300">{label}</span>}
        </label>
    )
}
